<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 178.61 176.41"
		:class="page"
	>
		<title>bug</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path
					class="cls-1"
					d="M42.57,156.15a6.21,6.21,0,0,0-6.84-4.63,20,20,0,0,1-5.53-.24,15.5,15.5,0,0,1-10.44-6.45,16.63,16.63,0,0,1-3.8-10,16.87,16.87,0,0,1,3.8-11.46h-.24q-10.56,0-16-8.36a15.21,15.21,0,0,1-2.33-6.57,18.17,18.17,0,0,1,.62-6.93,16.24,16.24,0,0,1,3.31-6.21l.17-.2a6,6,0,0,0-.27-8.26,18.24,18.24,0,0,1-3-4.09A17.06,17.06,0,0,1,.36,71a16.11,16.11,0,0,1,6-9.8,19.39,19.39,0,0,1,4.44-2.43,5.88,5.88,0,0,0,3.44-7.42,17.82,17.82,0,0,1-.88-5.08,15.69,15.69,0,0,1,3.93-11.35,18.5,18.5,0,0,1,9.21-5.73,16.59,16.59,0,0,1,5.25-.64,6.25,6.25,0,0,0,6.5-5.4,18.25,18.25,0,0,1,1.26-4.59,17.29,17.29,0,0,1,7.59-8.5,8.52,8.52,0,0,1,.8-.4,21.41,21.41,0,0,1,11.5-1.25A15.55,15.55,0,0,1,64.35,10a6.23,6.23,0,0,0,8-2.07A17.57,17.57,0,0,1,85.82.05a18.9,18.9,0,0,1,12,3.23,16.53,16.53,0,0,1,3.94,3.56,6.18,6.18,0,0,0,8,1.67,16.1,16.1,0,0,1,4.42-1.77,20.83,20.83,0,0,1,11.67.48,17.45,17.45,0,0,1,9.21,7.89,16.23,16.23,0,0,1,1.77,4.74,6.28,6.28,0,0,0,6.73,5,17.53,17.53,0,0,1,5.62.51,17,17,0,0,1,10.31,7.16,16.65,16.65,0,0,1,3.44,9.8,14.75,14.75,0,0,1-.52,4.61,6.16,6.16,0,0,0,4.1,7.33,26.28,26.28,0,0,1,4.89,2.39q5.78,3.59,6.26,11.23t-2.33,11.47a22.44,22.44,0,0,1-7,6.21.21.21,0,0,1-.24.24h-.25q12.27,6,10.56,19.11a14.63,14.63,0,0,1-5.65,10.27,17.83,17.83,0,0,1-4.51,2.8,6,6,0,0,0-3.18,7.49,16.67,16.67,0,0,1,.81,5.24,15.82,15.82,0,0,1-4.66,11.47,20.33,20.33,0,0,1-9.09,5.26,15.73,15.73,0,0,1-4.83.64,6.25,6.25,0,0,0-6.41,5.33,15.9,15.9,0,0,1-1.65,5,18.47,18.47,0,0,1-8.37,8.43c-.23.11-.47.21-.71.3a21.55,21.55,0,0,1-10.56.94,15.08,15.08,0,0,1-4.85-1.52,6.44,6.44,0,0,0-8.29,2.08,18.2,18.2,0,0,1-3.69,4A16.18,16.18,0,0,1,91,176.36a18.18,18.18,0,0,1-10.32-3.7,16.9,16.9,0,0,1-3.26-3.17,6.41,6.41,0,0,0-8.3-1.6,19.26,19.26,0,0,1-5,2,16.77,16.77,0,0,1-12.16-1.19,17.36,17.36,0,0,1-7.86-8.24A19.22,19.22,0,0,1,42.57,156.15Z"
				/>
				<path
					class="cls-2"
					d="M89.82,48.45H89.3A37.26,37.26,0,0,0,88.79,123h.52a37.26,37.26,0,0,0,.51-74.51Zm-.51,70.71h-.46a33.45,33.45,0,0,1,.45-66.89h.46a33.45,33.45,0,0,1-.45,66.9ZM77.43,91.58c4.46,0,6.36-2.51,6.36-8.38,0-4.52-1.25-6.55-4.93-8l-1.63-.64c-1.81-.71-2.62-1.54-2.62-4.61,0-3.4,1.14-4.09,2.86-4.09,1.45,0,2.81.49,2.94,4a1,1,0,0,0,.38.79,1,1,0,0,0,.83.15l1.12-.19.1,0a1,1,0,0,0,.71-1c-.13-4.55-2.19-6.86-6.12-6.86S71.32,65.13,71.32,70c0,4.46,1.2,6.36,5,7.82l1.63.64c1.74.68,2.57,1.59,2.57,5,0,4.59-1.37,5-3,5-1.83,0-3-.77-3.3-4.61a1,1,0,0,0-.35-.78.93.93,0,0,0-.84-.16l-1.17.24c-.31,0-.81.25-.81,1.09C71.21,89.09,73.38,91.58,77.43,91.58ZM106.78,97H71.83a1,1,0,0,0-1,1v4.79c0,3.35,1.43,5.44,4.39,6.4,1.5.49,3.17.66,9.57.66.17,0,16.63,0,18.64-.66,3-1,4.39-3,4.39-6.4V98A1,1,0,0,0,106.78,97Zm-2,5.56c0,1.95-.67,3-2.3,3.53-1,.31-10.15.52-17.8.52-6,0-7.5-.16-8.62-.52-1.64-.56-2.31-1.58-2.31-3.53v-2.3h31ZM107,75.93h-5.08a1,1,0,0,0-1,1v1.11a1,1,0,0,0,1,1h2.82c0,5.85-.13,6.54-.36,7.3a3.13,3.13,0,0,1-5.79,0c-.25-.82-.37-1.56-.37-9.31s.12-8.49.36-9.29a2.69,2.69,0,0,1,2.86-2c1.89,0,2.93,1.05,3.27,3.32a1,1,0,0,0,1.23.8l1.15-.24.07,0a1,1,0,0,0,.71-1.2c-.51-3.79-2.79-5.88-6.43-5.88-3.07,0-5.16,1.43-6,4.13-.44,1.31-.55,2.5-.55,10.33s.11,9,.54,10.33c.89,2.7,3,4.13,6,4.13s5.16-1.43,6-4.13c.44-1.31.55-2.41.55-9.42V77A1,1,0,0,0,107,75.93Z"
				/>
				<text class="cls-3" transform="translate(44.18 61.93) rotate(-54.65)">
					C
				</text>
				<text
					class="cls-3"
					transform="matrix(0.73, -0.68, 0.68, 0.73, 49.67, 54.06)"
				>
					O
				</text>
				<text
					class="cls-3"
					transform="matrix(0.86, -0.5, 0.5, 0.86, 58.23, 46.14)"
				>
					O
				</text>
				<text class="cls-3" transform="translate(68.43 40.38) rotate(-18.78)">
					K
				</text>
				<text class="cls-3" transform="translate(77.34 37.44) rotate(-8.95)">
					E
				</text>
				<text class="cls-3" transform="matrix(1, 0.04, -0.04, 1, 85.76, 36.03)">
					D
				</text>
				<text
					class="cls-3"
					transform="translate(97.17 36.76) rotate(10.61)"
				></text>
				<text class="cls-3" transform="translate(101.22 37.3) rotate(18.96)">
					U
				</text>
				<text class="cls-3" transform="translate(111.63 41.03) rotate(29.96)">
					P
				</text>
				<text
					class="cls-3"
					transform="translate(119.6 45.86) rotate(37.41)"
				></text>
				<text class="cls-3" transform="translate(122.96 48.27) rotate(44.94)">
					B
				</text>
				<text class="cls-3" transform="translate(129.41 54.75) rotate(55)">
					Y
				</text>
				<text
					class="cls-3"
					transform="translate(134.66 62.63) rotate(62.46)"
				></text>
				<text class="cls-3" transform="translate(28.98 100.37) rotate(74.86)">
					S
				</text>
				<text class="cls-3" transform="translate(31.81 110.34) rotate(64.36)">
					A
				</text>
				<text
					class="cls-3"
					transform="matrix(0.59, 0.81, -0.81, 0.59, 37.41, 121.3)"
				>
					E
				</text>
				<text
					class="cls-3"
					transform="matrix(0.69, 0.73, -0.73, 0.69, 43.48, 129.17)"
				></text>
				<text
					class="cls-3"
					transform="matrix(0.79, 0.62, -0.62, 0.79, 47.23, 133.31)"
				>
					D
				</text>
				<text class="cls-3" transform="translate(57.9 141.17) rotate(26.92)">
					E
				</text>
				<text class="cls-3" transform="translate(67.09 145.63) rotate(17.51)">
					S
				</text>
				<text
					class="cls-3"
					transform="matrix(0.98, 0.18, -0.18, 0.98, 76.69, 148.39)"
				>
					I
				</text>
				<text class="cls-3" transform="translate(82.62 149.53) rotate(1.36)">
					G
				</text>
				<text class="cls-3" transform="translate(95.72 149.57) rotate(-10.97)">
					N
				</text>
				<text
					class="cls-3"
					transform="translate(108.19 146.72) rotate(-19.51)"
				></text>
				<text class="cls-3" transform="translate(113.44 144.97) rotate(-27.88)">
					G
				</text>
				<text
					class="cls-3"
					transform="matrix(0.78, -0.63, 0.63, 0.78, 124.75, 138.62)"
				>
					R
				</text>
				<text
					class="cls-3"
					transform="matrix(0.63, -0.78, 0.78, 0.63, 133.43, 131.38)"
				>
					O
				</text>
				<text class="cls-3" transform="translate(141.91 120.44) rotate(-63.47)">
					U
				</text>
				<text
					class="cls-3"
					transform="matrix(0.27, -0.96, 0.96, 0.27, 147.39, 108.72)"
				>
					P
				</text>
			</g>
		</g>
	</svg>
</template>

<script>
	export default {
		name: "SDGBug",
		props: ["page"]
	};
</script>

<style lang="scss" scoped>
	svg {
		position: absolute;
		z-index: 10;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	.results {
		display: none;
	}

	.home {
		width: 150px;
		top: 12vh;
		animation: spin 10s linear infinite;
	}

	@media (min-width: $breakpoint-small) {
		.home {
			display: none;
		}
	}

	@media (min-width: $breakpoint-medium) {
		.results {
			width: 10em;
			top: 2.5%;
			right: 2.5%;
			width: 150px;
			animation: spin 15s linear infinite;
			display: block;
		}
	}

	.cls-1 {
		fill: #fff;
	}
	.cls-2 {
		fill: #e1c487;
	}
	.cls-3 {
		font-size: 16.25px;
		fill: #eb2e57;
		font-family: $type-base;
		font-weight: 800;
	}
</style>
